
import useAddMutation from "./helper/useAddMutation"
import useDeleteMutation from "./helper/useDeleteMutation"
import useGetQuery from "./helper/useGetQuery"
import useUpdateMutationById from "./helper/useUpdateMutationById"

  const API = {
    GET: "/api/admin/recent_works",
    ADD: "/api/admin/recent_works",
    UPDATE: "/api/admin/recent_works",
    DELETE: "/api/admin/recent_works",
  };

  const KEY = "RECENT_WORKS";
  export const useGetRecentWorks = (params?:any) => useGetQuery(KEY, API.GET, params);
  export const useAddRecentWorks = () => useAddMutation(KEY, API.ADD);
  export const useUpdateRecentWorks = () => useUpdateMutationById(KEY, API.UPDATE);
  export const useDeleteRecentWorks = () =>useDeleteMutation(KEY, API.DELETE);
